<template>
  <v-card class="text-center pa-8" data-testid="empty_state">
    <v-icon size="80" color="grey lighten-1">mdi-chart-timeline-variant</v-icon>
    <h2 class="mt-4 mb-2">{{ $t('title') }}</h2>
    <p class="text--secondary mb-6">{{ $mpt($t('description_timeline')) }}</p>
    <v-btn
      color="primary"
      large
      @click="$emit('create')"
      data-testid="empty_state_create_button"
    >
      <v-icon left>mdi-plus</v-icon>
      {{ $t('create_button') }}
    </v-btn>
  </v-card>
</template>

<i18n lang="yaml">
ja:
  title: 管理施設を作成して、検出データを可視化しましょう
  description_timeline: 複数センサーの検出傾向を時間帯別に確認できます
  create_button: 管理施設を作成
en:
  title: Create a facility to visualize detection data
  description_timeline: View detection trends of multiple sensors by time period
  create_button: Create facility
</i18n>

<script>
export default {
  name: 'r-type-place-empty-state',
};
</script>
